import * as React from 'react';
import styled from 'styled-components';
import { Link } from "react-router-dom";
import { Button, IconLogo, media } from '@payright/web-components';

/////////////////////////////////////////////////
//            Navigation: Customer             //
/////////////////////////////////////////////////

const SCNotLoggedInNav = styled.div`
  display: flex;
  align-items: center;
  .logged-in,
  .not-logged-in {
    height: 100%;
    display: flex;
    align-items: center;
    padding: 0 1.6em;

    h6 {
      margin-right: 1.6em;
      ${media.max.large} {
        display: none;
      }
    }
    button {
      height: 36px;
      width: 93px;
    }
  }
`;

const SCNavContainer = styled.nav<NotLoggedInNavProps>`
  height: 88px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  user-select: none;
  position: relative;

  .ml-1 {
    margin-left: 0.25rem;
  }

  &:hover {
    overflow: unset;
  }
  ${(props) => media.min[props.breakpoint]} {
    background-color: ${(props) => props.theme.colours.white};
  }
  .navigation-header {
    ${(props) => media.max[props.breakpoint]} {
      z-index: 9999;
    }
    background-color: ${(props) => props.theme.colours.white};
    position: relative;
    height: 100%;
    align-items: center;

    .logo {
      margin-left: 1.66em;
      height: 100%;
      display: flex;
      align-items: center;
      svg {
        width: 130px;
        height: 33px;
      }
      ${(props) => media.max[props.breakpoint]} {
        margin-left: 1.4em;
        svg {
          width: 90px;
        }
      }
    }
  }

  ${(props) => media.max[props.breakpoint]} {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.04);
    flex-direction: row;
    background-color: ${(props) => props.theme.colours.white};

    .navigation-header {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
  }
`;


export type NotLoggedInNavProps = {
  breakpoint: string;
};

const NavNotLoggedIn: React.FC<{}> = () => (
  <SCNavContainer breakpoint={'wide'}>
    <div className="navigation-header">
      <div className="logo">
        <a href="/">
          <IconLogo height={28} width={130} />
        </a>
      </div>
    </div>
    <SCNotLoggedInNav>
      <div className="not-logged-in">
        <h6>Already have a Payright account?</h6>
        <Link to={'/login'}>
          <Button>Login</Button>
        </Link>
      </div>
    </SCNotLoggedInNav>
  </SCNavContainer>
);

export default NavNotLoggedIn;
